<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  props: {
    agentAccountList: Array,
    sourceData: Object
  },
  data() {
    const pageCount = this.sourceData.totalPages;
    return {
      checkBoxSelect: true,
      pageCount,
      activePage: this.sourceData.number + 1
    };
  },
  methods: {
    pageClick(page) {
      this.encodeToUrl({
        page: page
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      let params = {
        page: this.activePage - 1
      };
      this.$emit("handleCurrentChange", "agentAccountList", params);
    }
  }
};
</script>

<template>
  <div class="AgentDetailAccountsIndex">
    <el-table
      :data="agentAccountList"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="createdAt" align="left" label="创建时间" min-width="80"></el-table-column>
      <el-table-column prop="name" align="left" label="姓名" min-width="80"></el-table-column>
      <el-table-column prop="gender" align="left" label="性别" min-width="60"></el-table-column>
      <el-table-column prop="phone" align="left" label="联系电话" min-width="90"></el-table-column>
      <el-table-column prop="auth" align="left" label="权限">
        <template slot-scope="scope">
          <el-checkbox
            v-for="item in scope.row.auths"
            :key="scope.row.id + item"
            v-model="checkBoxSelect"
            class="checkBoxLabel"
            disabled
          >{{item}}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginAt" align="left" label="上次登录时间" width="180"></el-table-column>
    </el-table>
    <PagenationContainer >
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentDetailAccountsIndex {
  .AgencyAccountTable {
    margin: 20px auto;
    border: 1px;
    width: 97%;
    .checkBoxLabel {
      color: #303133;
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Agent/AgentAccounts.vue